


















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import FlightPayments from '@/store/entities/flight/flightPayment';
import Passenger from '@/store/entities/order/passenger';
import VueI18n from 'vue-i18n';
import VCreditCard from 'v-credit-card';
import CreditCard from '@/store/entities/order/creditCard';
import AddOrder from '@/store/entities/order/addOrder';
import ajax from '@/lib/ajax';
import BasketFlightPassengerPrice from '@/store/entities/flight/basketFlightPassengerPrice';
import Customer from '@/store/entities/order/customer';
import Payment from '@/store/entities/order/payment';
import Headerhome from '@/components/headerhome.vue';
import moment from 'moment';
import Flight from '@/store/entities/flight';
import PaymentDialog from '@/components/paymentDialog.vue';
import 'v-credit-card/dist/VCreditCard.css';
import { setInteractionMode } from 'vee-validate';



@Component({
  components: {
    Headerhome,
    PaymentDialog,
    VCreditCard,
  },
})
export default class FlightPayment extends Vue {
  birthday: Date = null;
  radios: boolean = true;
  radios1: boolean = true;
  radios2: boolean = true;
  radios3: boolean = true;
  payment: Payment = new Payment();
  flightPayment: FlightPayments = new FlightPayments();
  passenger: Passenger = new Passenger();
  passengers: Passenger[] = [];
  passengersChild: Passenger[] = [];
  passengersInfant: Passenger[] = [];
  customer: Customer = new Customer();
  creditCard: any={};
  countryCode:any={};
  countries: any[] = [];
  addOrder: AddOrder = new AddOrder();
  dialog: boolean = false;
  dialogContract: boolean = false;
  dialogUkraine: boolean = false;
  dialogEgypt: boolean = false;

  checkbox: boolean = false;
  checkbox2: boolean = false;
  passengerPrice: BasketFlightPassengerPrice[] = [];
  basketId: string;
  nationality: any ={};
  newPrice: string;
  oldPrice: string;
  flight: any = {};
  generalFlightInfo: any = {};
  paymentDialog: boolean = false;
  errorMessages: string[] = [];
  isLoading: boolean = false;
  cardNumber:string;
  customerGsm:string="";
  marker:string="123";
  orderId:string="00000000-0000-0000-0000-000000000000";
  $refs: {
    form: HTMLFormElement;
  };


    get getLanguage(){
   return this.$root.$i18n.locale;
  }


 creditInfoChanged(values){
    this.creditCard=values;
 }

  setMarker(){
    var markerAvia=this.getMarkerValue(window.location.href);
    console.log(markerAvia);
    var marker = abp.utils.getCookieValue('marker');
    
    if(window.location.href.includes('marker')){
      var markerAvia=this.getMarkerValue(window.location.href);
    if(markerAvia==undefined || markerAvia==null){
      markerAvia=this.getMarkerValueFromUrl(window.location.href);
      
   

               if (markerAvia==null) {

                   this.marker=marker;
               }
               else if (markerAvia!=null){
                  this.marker=markerAvia.toString().replace('#','');
                   abp.utils.setCookieValue('marker', this.marker);
               }
    
              }
              else{
                this.marker=markerAvia.toString().replace('#','');
                   abp.utils.setCookieValue('marker', this.marker);
              }
            }

   else{
    this.marker=marker;
   }
    
  
  }
  getMarkerValueFromUrl(url) {
  // URL'yi "?" karakterine göre böl
  var parts = url.split("?");

  // "?currency=RUB%3Fmarker%3Djwt69p1egva8" parçasını al
  var queryPart = parts[1].split("=")[1];
  // "RUB?marker=jwt69p1egva8" ifadesini al
  var markerPart = decodeURIComponent(queryPart);

  // "&" karakterine göre böl
  var markerParams = markerPart.split("?");

  // "marker" parametresini ara
  for (var i = 0; i < markerParams.length; i++) {
    if (markerParams[i].startsWith("marker=")) {
      var markerValue = markerParams[i].split("=")[1];
      return markerValue;
    }
  }

  // "marker" parametresi bulunamazsa null döndür
  return null;
}






  getMarkerValue(url) {
    // URL'i "#" karakterine göre bölerek hash parçasını al
    const parts = url.split('#');

// İlk parçayı sorgu parametreleri için kontrol et
const queryString1 = parts[0].split('?')[1];

// İkinci parçayı sorgu parametreleri için kontrol et
const queryString2 = parts[1] ? parts[1].split('?')[1] : '';

// URLSearchParams ile sorgu parametrelerini ayrıştır
const params1 = new URLSearchParams(queryString1);
const params2 = new URLSearchParams(queryString2);

// "marker" parametresinin değerini al
const markerValue1 = params1.get('marker');
const markerValue2 = params2.get('marker');

// Marker parametresini bulduğumuzda döndür
if (markerValue1) {
  return markerValue1;
}
if (markerValue2) {
  return markerValue2;
}

// "marker" parametresi bulunamazsa null döndür
return null;
  }


 
  async created() {

    setInteractionMode('lazy');

     this.setMarker();
  
  
    this.isLoading = true;
    const payload = {
      ...this.$route.params,
      currencyId: this.currencyFormat,
    };
    const response = await ajax.post(
      '/api/services/app/Booking/AddBasket',
      payload
    );
    this.basketId = response.data.result;
    await ajax
      .get('/api/services/app/Booking/GetBasketById', {
        params: { id: response.data.result },
      })
      .then((response) => {
        this.flightPayment = response.data.result;
        this.generalFlightInfo = this.flightPayment.flightItems[0];
        this.flight = this.flightPayment.flightItems[0].flight;
 
       
        this.passengerPrice =
          response.data.result.flightItems[0].basketFlightPassengerPrices;
        for (
          let i = 0;
          i < response.data.result.flightItems[0].adultCount;
          i++
        ) {
          this.passengers.push(new Passenger());
          const filterArray = this.flightPayment.flightItems[0].basketFlightPassengerPrices.find(
            (t) => t.passengerType === 1
          );
          this.passengers.map((item, index) => {
            item.direction = 0;
            item.flightClass = '';
            item.flightClassId = 'Economy';
            item.flightClassName = 'Economy - Y';
            item.flightId = this.$route.params.flightId;
            item.flightSegmentId = 'Y';
            item.rowNumber = `${index}`;
            item.price = filterArray.price;
            item.passengerType = 1;
          });
        }
        for (
          let i = 0;
          i < response.data.result.flightItems[0].childCount;
          i++
        ) {
          this.passengersChild.push(new Passenger());
          const filterArray = this.flightPayment.flightItems[0].basketFlightPassengerPrices.find(
            (t) => t.passengerType === 2
          );
          this.passengersChild.map((item, index) => {
            item.direction = 0;
            item.flightClass = '';
            item.flightClassId = 'Economy';
            item.flightClassName = 'Economy - Y';
            item.flightId = this.$route.params.flightId;
            item.flightSegmentId = 'Y';
            item.rowNumber = `${index}`;
            item.price = filterArray.price;
            item.passengerType = 2;
          });
        }
        for (
          let i = 0;
          i < response.data.result.flightItems[0].infantCount;
          i++
        ) {
          this.passengersInfant.push(new Passenger());
          const filterArray = this.flightPayment.flightItems[0].basketFlightPassengerPrices.find(
            (t) => t.passengerType === 3
          );
          this.passengersInfant.map((item, index) => {
            item.direction = 0;
            item.flightClass = '';
            item.flightClassId = 'Economy';
            item.flightClassName = 'Economy - Y';
            item.flightId = this.$route.params.flightId;
            item.flightSegmentId = 'Y';
            item.rowNumber = `${index}`;
            item.price = filterArray.price;
            item.passengerType = 3;
          });
        }
      });
    
    await ajax
      .get('/api/services/app/Content/GetCountries')
      .then((res) => (this.countries = res.data.result.items));

    this.isLoading = false;
  
    if (this.flightPayment.currencyId !== this.currencyFormat) {
      this.priceFormatter(this.flightPayment.currencyId);
    } else {
      return;
    }
  }

  async emitDialog(e) {

    this.paymentDialog=false;
    const payload = {
      orderId: this.$store.state.payment.orderId,
    };
    const response = await ajax.post(
      'api/services/app/Booking/GetOrderById',
      payload
    );
    if(response.data.result.orderStatus==4){
      
      this.$router.push('/ticketDetail/' + payload.orderId);
    }else{

      this.$swal({
    icon: 'warning',
    title: String(this.$t('PaymentError')),
    text: String(this.$t('PaymentFailed')),
    confirmButtonText: String(this.$t('OK'))
})
    }

 
  }

  changeNationalty(item){
    
    if(this.flightPayment.flightItems[0].flight.fromAirport.countryName=="Turkey"&&this.flightPayment.flightItems[0].flight.toAirport.countryName=="Russia" && item=="UA"){
      this.dialogUkraine=true;
      
    }
    if(this.flightPayment.flightItems[0].flight.fromAirport.countryName=="Egypt"&&this.flightPayment.flightItems[0].flight.toAirport.countryName=="Russia" && (item=="EG" || item=="RU")){
      this.dialogEgypt=true;
      
    }
  }
  key (index, item) {
        return `${index}${item.passengerType}`
    }
  async saveOrder(e) {

   
    
    this.errorMessages = [];
    this.$refs.form.validate().then(async (success) => {
      debugger;
      if (!success) {
        let errors = this.$refs.form.errors;
     
  
        for (const [key, value] of Object.entries(errors)) {
        
          if( value!=0){
           
            this.errorMessages.push(
            `${this.$i18n.t(key.toString())}: ${value}`
          );
          }
        
        }
        this.dialog = true;

        return;
      }
    
   
     this.paymentDialog = true;
      let addOrder = new AddOrder();
      addOrder.marker=this.marker;
       addOrder.creditCard=new CreditCard();
      if(this.flightPayment.currencyId != 'RUB') {
     
      addOrder.creditCard.cardNumber = this.creditCard.cardNumber;
      addOrder.creditCard.cardOwner=this.creditCard.name;
      addOrder.creditCard.cvc=this.creditCard.security;
     
      let exprirations = this.creditCard.expiration.split('/');
      addOrder.creditCard.expiryMonth=exprirations[0];
      addOrder.creditCard.expiryYear=exprirations[1];


      }
      addOrder.customer = this.customer;
      addOrder.orderId=this.orderId;

      
   
      let fullGsm =this.countryCode.phoneCode + ' ' + this.customerGsm;
    
      addOrder.customer.gsm = fullGsm;
      addOrder.isWeb = true;
      addOrder.payment = {
        hostAddress: 'charterscanners.com',
        paymentType: 'creditCard',
        paymentTotal: this.flightPayment.total,
      };
      addOrder.flightId=this.$route.params.flightId;
      addOrder.returnFlightId=this.$route.params.returnFlightId
      addOrder.passengers = [
        ...this.passengers,
        ...this.passengersChild,
        ...this.passengersInfant,
      ];
      addOrder.requestId = this.$route.params.searchId;
     
      if(localStorage.currency==null){
        addOrder.currency = { id: this.flightPayment.currencyId };  
      }
      else{
        addOrder.currency = { id: this.flightPayment.currencyId };
      }
   
      addOrder.basket = { id: this.basketId };
    var orderId=await this.$store.dispatch({
    type: 'payment/addOrder',
    data: addOrder,
    });
    
    this.orderId=orderId;
   });
   
  }
isLetter(item) {

  
  if(item.match(/[\w\p{sc=Cyrillic}]+/ug)){
    item="test";
  } // Match with regex 

}
  async priceFormatter(currencyId) {
    const payload = {
      amount: this.flightPayment.total,
      firstCurrencyId: currencyId,
      secondCurrencyId: this.$store.state.currency.id,
    };
    const response = await ajax.post(
      '/api/services/app/Booking/ConvertExchangeRate',
      payload
    );
    this.flightPayment.total = response.data.result.total;
    this.flightPayment.currencyId = response.data.result.secondCurrencyId;
  }

  async changeFlightList() {
    await this.priceFormatter(this.flightPayment.currencyId);
  }

  get totalCount() {
    return (
      this.generalFlightInfo.adultCount +
      this.generalFlightInfo.childCount +
      this.generalFlightInfo.infantCount
    );
  }

  


  get totalPrice() {
    return this.flightPayment.total + ' ' + this.flightPayment.currencyId;
  }

  get currencyFormat() {
    return this.$store.state.currency.id;
  }

  @Watch('currencyFormat', { immediate: true, deep: true })
  onChangeCurrencyFormat(price, oldPrice) {
    if (oldPrice === undefined) {
      return;
    } else if (oldPrice == undefined) {
      return;
    } else if (price !== oldPrice && oldPrice !== null && oldPrice !== '') {
      this.priceFormatter(oldPrice);
    }
  }

  set currencyFormat(value) {
    this.newPrice = value;
  }

  get nowDate() {
    return moment(new Date()).format('DD-MM-yyyy');
  }

  get maxAdultDate() {
    return moment(new Date())
      .subtract(99, 'years')
      .format('DD-MM-yyyy');
  }
  get minAdultDate() {
    return moment(new Date())
      .subtract(12, 'years')
      .format('DD-MM-yyyy');
  }

  get maxChildDate() {
    return moment(new Date())
      .subtract(12, 'years')
      .format('DD-MM-yyyy');
  }
  get minChildDate() {
    return moment(new Date())
      .subtract(2, 'years')
      .format('DD-MM-yyyy');
  }

  get maxInfantDate() {
    return moment(new Date())
      .subtract(2, 'years')
      .format('DD-MM-yyyy');
  }

  get pasaportInvalidDate() {
    return moment(this.flightPayment.flightItems[0].flight.departureDate)
      .add(120, 'days')
      .format('DD-MM-yyyy');
  }
}
